import { Check } from "lucide-react";
import { WHY, IMG } from "@/lib/site";
import { Reveal, Eyebrow } from "@/components/Reveal";

export const WhyUs = () => (
  <section id="warum" data-testid="why-section" className="relative w-full bg-white text-[#0a0a0a] py-20 sm:py-24 lg:py-32">
    <div className="w-full px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-10 lg:gap-16">
      <div className="lg:col-span-4">
        <Reveal>
          <Eyebrow chapter="05" dark>
            Vertrauen
          </Eyebrow>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display uppercase font-black leading-[0.9] tracking-tight text-[clamp(2.1rem,7vw,4rem)]">
            Warum Global Move Europa?
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-5 text-[15px] sm:text-base text-neutral-600 leading-relaxed">
            Wir arbeiten mit klaren Absprachen statt großer Versprechen. Was wir zusagen, halten wir –
            und was nicht geht, sagen wir Ihnen vorher.
          </p>
        </Reveal>
        <Reveal delay={0.15} className="mt-8 relative overflow-hidden hidden lg:block">
          <img src={IMG.loadingDark} alt="Gesicherte Ladung im Transporter" loading="lazy" className="w-full h-64 object-cover" />
          <span className="absolute inset-0 ring-1 ring-inset ring-black/10" />
        </Reveal>
      </div>

      <div className="lg:col-span-8 grid sm:grid-cols-2 gap-px bg-neutral-200 self-start">
        {WHY.map((w, i) => (
          <Reveal key={w.t} delay={(i % 2) * 0.06} className="group bg-white p-6 sm:p-7 lg:p-9 relative overflow-hidden">
            <span className="absolute top-0 left-0 h-full w-[3px] bg-[#f95700] scale-y-0 origin-top transition-transform duration-500 group-hover:scale-y-100" />
            <div className="flex items-start gap-4">
              <span className="w-8 h-8 shrink-0 grid place-items-center bg-[#0a0a0a] group-hover:bg-[#f95700] transition-colors duration-500">
                <Check size={16} className="text-white" strokeWidth={3} />
              </span>
              <div>
                <h3 className="font-display text-lg sm:text-xl font-bold uppercase tracking-tight leading-tight">{w.t}</h3>
                <p className="mt-2 text-sm text-neutral-600 leading-relaxed">{w.d}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
